import React, { Component } from "react";
import styles from './styles.css'

class Project extends Component {
  render() {
    var projectStyle = { backgroundColor: this.props.color }

    return (
      <a title={this.props.name} href={this.props.link} style={projectStyle} className='project'>
        <div>
          <img className='project__logo' src={this.props.logo}></img>
        </div>
      </a>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project/index.js